export const Experiments = {
  donate_now_track_click: 'donate_now_track_click',

  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },

  IncreaseShareModalOptionsFeature: {
    featureKey: 'consumerairwalk_frp_shareclick_increase_share_options',
    IncreaseShareModalOptionsExperiment: {
      experimentKey: 'consumerairwalk_frp_shareclick_increase_share_options',
      variations: {
        IncreasedShareModalOptions: 'increased_share_modal_options',
        LegacyFrpDefaultShareModal: 'legacy_frp_default_share_modal',
      },
    },
  },

  DonateButtonVariationsFeature: {
    featureKey: 'consumerairwalk_frp_donate_variations',
    DonateButtonVariationsExperiment: {
      experimentKey: 'consumerairwalk_frp_donate_variations',
      variations: {
        defaultButton: 'default_button',
        animationHeartIcon: 'animation_heart_icon',
        animationShieldIcon: 'animation_shield_icon',
        defaultWithAnimation: 'animation_heart_icon',
        noAnimationHeartIcon: 'no_animation_heart_icon',
        noAnimationShieldIcon: 'no_animation_shield_icon',
      },
    },
  },

  ConsumerFintech: {
    CheckoutConversion: {
      EmbeddedCheckoutF4: {
        flag: 'consumerfintech_jgcheckout_conversion_embedded_checkout_f4',
        applePayFlag:
          'consumerfintech_jgcheckout_conversion_embedded_checkout_f4_applepay',
      },
    },
  },
};
